import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import { userStyles } from '../styles';
import {
  WithStyles,
  createStyles,
  Grid,
  Card,
  CardContent,
  Typography,
  MenuItem,
  Checkbox,
  Select,
  withStyles,
  TableHead,
  Paper,
} from '@material-ui/core';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableFooter from '@material-ui/core/TableFooter';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import Highlighted from '../../common/Highlighted';
// import { markSearchText } from '../../common/MarkSearchText';

interface TabularDatanProps extends WithStyles<typeof userStyles> {
  currentPage: number;
  headers: any;
  dataKeys: any;
  data: any;
  action: any;
  permission: any;
  searchQuery: string;
}

class TabularData extends Component<TabularDatanProps> {
  state = {
    currentPage: 1,
    headers: null,
    dataKeys: null,
    data: null,
    action: null,
    permission: null,
  };

  constructor(props: any) {
    super(props);
    let { currentPage, headers, dataKeys, data, action, permission } = props;
    this.setState(
      {
        currentPage: currentPage,
        headers: headers,
        dataKeys: dataKeys,
        data: data,
        action: action,
        permission: permission,
      },
      () => {
        this.renderTable();
      }
    );
  }

  static getDerivedStateFromProps(nextProps: any, prevState: any) {
    // do things with nextProps.someProp and prevState.cachedSomeProp
    return {
      currentPage: nextProps.currentPage,
      headers: nextProps.headers,
      dataKeys: nextProps.dataKeys,
      data: nextProps.data,
      action: nextProps.action,
      permission: nextProps.permission,
    };
  }

  handleChangePage = () => {}; // Pagination Handler

  formatExpiryDate = (expiryDate: any) => {
    let formattedExpiryDate = expiryDate.toString();

    let dateElements = formattedExpiryDate.split('T')[0].split('-');
    const newExpiryDate =
      dateElements[2] + '/' + dateElements[1] + '/' + dateElements[0];

    return newExpiryDate;
  };

  render() {
    const { classes, currentPage } = this.props;
    let table = this.renderTable(
      currentPage,
      this.state.headers,
      this.state.dataKeys,
      this.state.data,
      this.state.action,
      this.state.permission
    );

    return <>{table}</>; // REturn <Table>
  }

  renderTable = (
    currentPage?: any,
    headers?: any,
    dataKeys?: any,
    data?: any,
    action?: any,
    permission?: any
  ) => {
    const { classes } = this.props;
    let headersJSX = this.renderHeaders(
      this.state.headers,
      this.state.action,
      this.state.permission
    );
    let dataJSX = this.renderData(
      currentPage,
      this.state.dataKeys,
      this.state.data,
      this.state.action,
      this.state.permission
    );

    let table = (
      <Table classes={{ root: classes.table }} padding="checkbox">
        <TableHead classes={{ root: classes.tableHead }}>
          <TableRow>{headersJSX}</TableRow>
        </TableHead>
        <TableBody>{dataJSX}</TableBody>

        <TableBody />
      </Table>
    );
    return table;
  };

  renderHeaders = (headers: any, action: any, permission: any) => {
    // Return a list of TableCell Elements
    const { classes } = this.props;
    let headerCells =
      headers !== null &&
      headers.map((header: any, index: any) => {
        return (
          <TableCell
            key={index}
            classes={{ head: classes.textSM, root: classes.tableCell }}
            align="center"
          >
            {header}
          </TableCell>
        );
      });
    return headerCells;
  };

  renderData = (
    currentPage: any,
    dataKeys: any,
    data: any,
    action: any,
    permission: any
  ) => {
    // Return List of TableRows with TableCells each
    // Based on dataKeys, build row of relevant TableCells including/excluding action or permission TableCells
    const { classes, searchQuery } = this.props;
    const pageNumber = (currentPage - 1) * 10;
    let dataRows =
      data.length !== 0 &&
      data.map((record: any, index: any) => {
        return (
          <TableRow key={record._id} classes={{ root: classes.tableRow }}>
            <TableCell
              key={record._id}
              classes={{ root: classes.tableCell }}
              component="th"
              scope="row"
              align="center"
            >
              {pageNumber + (index + 1)}
            </TableCell>
            <TableCell classes={{ root: classes.tableCell }} align="center">
               <Highlighted text={record.name} highlight={searchQuery}/>
              
              {record.name.length > 29 ? (
                <Grid className="tooltip">{record.name}</Grid>
              ) : (
                ''
              )}
            </TableCell>
            <TableCell classes={{ root: classes.tableCell }} align="center">
              <span>
                {record.address ? record.address : '-'}
                {record.address.length > 29 ? (
                  <Grid className="tooltip">
                    {record.address ? record.address : '-'}
                  </Grid>
                ) : (
                  ''
                )}
              </span>
            </TableCell>
            <TableCell classes={{ root: classes.tableCell }} align="center">
              <span>
                {record.license &&
                record.license.type &&
                record.license.type === 'unlimited'
                  ? 'Lifetime'
                  : record.license &&
                    record.license.type &&
                    record.license.type === 'subscription'
                  ? this.formatExpiryDate(record.license.endDate)
                  : 'Not Yet Provided'}
                {/* <Grid className="tooltip"> 
          {record.license && record.license.type && record.license.type === 'unlimited'? 'Lifetime' : record.license && record.license.type && record.license.type === 'subscription' ? this.formatExpiryDate(record.license.endDate) : 'Not Yet Provided'}
          </Grid> */}
              </span>
            </TableCell>
            {action.isEdit && (
              <TableCell classes={{ root: classes.tableCell }} align="center">
                <Link
                  to={`${action.editURL}${record._id}`}
                  style={{ textDecorationUnderline: 'none' }}
                >
                  Edit
                </Link>
              </TableCell>
            )}
          </TableRow>
        );
      });
    return dataRows;
  };
}

const mapStateToProps = (state: any) => ({});

const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(userStyles)(TabularData));
